/* import __COLOCATED_TEMPLATE__ from './attribute-popover.hbs.js'; */
var _dec, _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
//@ts-ignore
import { ref } from 'ember-ref-bucket';
let AttributePopover = (_dec = ref('inserterOpener'), (_class = class AttributePopover extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "isExpanded", _descriptor, this);
    _initializerDefineProperty(this, "inserterOpener", _descriptor2, this);
    _defineProperty(this, "attributePlaceholder", 'REPLACE_THIS');
  }
  get insertionPointRect() {
    let rect = this.inserterOpener?.getBoundingClientRect();
    return new DOMRect(rect?.x, rect?.y, 0, 0);
  }
  get popoverOffset() {
    return [0, 5];
  }
  get attributeResolver() {
    return this.args.composer.config.templating?.resolver;
  }
  onInsert(attributePath) {
    let attributeObject = this.createAttributeTemplate(attributePath);
    this.args.onInsert(attributeObject.attributeTemplate, attributeObject.attributeTemplateStartPosition, attributeObject.attributeTemplateEndPosition);
  }
  onClick(e) {
    let element = e.target;
    do {
      if (element.classList.contains('embercom-prosemirror-template-inserter-opener')) {
        return;
      }
    } while (element = element.parentElement);
    this.isExpanded = false;
  }
  createAttributeTemplate(attribute) {
    let object = {};
    if (this.attributeResolver?.requiresFallback(attribute, '')) {
      object.attributeTemplate = `{{ ${attribute}|fallback: "${this.attributePlaceholder}" }}`;
      object.attributeTemplateStartPosition = object.attributeTemplate.indexOf(this.attributePlaceholder);
      object.attributeTemplateEndPosition = object.attributeTemplate.indexOf(this.attributePlaceholder) + this.attributePlaceholder.length;
    } else {
      object.attributeTemplate = `{{ ${attribute} }}`;
    }
    return object;
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "isExpanded", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "inserterOpener", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "onInsert", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onInsert"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onClick"), _class.prototype)), _class));
export { AttributePopover as default };